import { ReactNode, useEffect, useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router';
import { useAuthStore } from '../store/authStore';

interface AuthGuardProps {
  children: ReactNode;
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const { isAuthenticated, validateToken, isLoading } = useAuthStore();
  const [isValidatingToken, setIsValidatingToken] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Validate token on mount
    const validateAndSetState = async () => {
      try {
        await validateToken();
      } finally {
        setIsValidatingToken(false);
      }
    };
    
    validateAndSetState();
  }, [validateToken]);

  useEffect(() => {
    // No realizar redirecciones hasta que se haya completado la validación del token
    if (isValidatingToken) {
      return;
    }

    const isLoginPage = location.pathname === '/login';
    
    console.log('AuthGuard check:', { 
      isAuthenticated, 
      pathname: location.pathname, 
      isLoginPage,
      isValidatingToken
    });
    
    // Guardar la URL actual antes de redirigir al login
    if (!isAuthenticated && !isLoginPage) {
      // Guardar la ruta actual para redirigir después del login
      sessionStorage.setItem('redirectUrl', location.pathname);
      console.log('Redirecting to login');
      navigate('/login', { replace: true });
    } else if (isAuthenticated && isLoginPage) {
      // Redirigir a la URL guardada o al dashboard por defecto
      const redirectUrl = sessionStorage.getItem('redirectUrl') || '/dashboard';
      console.log('Redirecting to', redirectUrl);
      navigate(redirectUrl, { replace: true });
      // Limpiar la URL guardada
      sessionStorage.removeItem('redirectUrl');
    } else {
      console.log('No redirection needed');
    }
  }, [isAuthenticated, location.pathname, navigate, isValidatingToken]);

  // Mostrar un indicador de carga mientras se valida el token
  if (isValidatingToken) {
    return <div className="flex items-center justify-center min-h-screen">Validating session...</div>;
  }

  return <>{children}</>;
}; 